import { createApp } from 'vue'
import './style/index.less'         // 引入全局样式
import 'virtual:windi.css'          // 引入windicss
import App from './App.vue'
import globalInit from './scripts'  // 全局脚本入口
import './assets/iconfont/iconfont.css'
// import '../public/static/iconfont/iconfont.css'

createApp(App)
  .use(globalInit)
  .mount('#app')
